<form [formGroup]="kpiInfoForm" *ngIf="kpiInfoForm">
  <div class="grid">

    <div class="col-12 md:col-12 lg:col-6 xl:col-4">
      <div class="form-field col-12">
        <label for="name">{{'attribute.name' | transloco}} (*)</label>
      </div>
      <div class="col-12">
        <input pInputText id="name" type="text" formControlName="name" class="w-full">
      </div>
      <app-validation-errors [control]="kpiInfoForm.get('name')"></app-validation-errors>
    </div>

    <div class="col-12 md:col-12 lg:col-6 xl:col-4">
      <div class="form-field col-12">
        <label for="description">{{'attribute.description' | transloco}}</label>
      </div>
      <div class="col-12">
        <input pInputText id="description" type="text" formControlName="description" class="w-full">
      </div>
      <app-validation-errors [control]="kpiInfoForm.get('description')"></app-validation-errors>
    </div>

    <div class="col-12 lg:col-6 xl:col-4" *ngIf="mode === 'create'">
      <div class="form-field col-12">
        <label for="creationMode">{{'misc.kpiCreationMode.label' | transloco}} (*)</label><br>
      </div>
      <div class="col-12">
        <p-dropdown
          [placeholder]="'select.generic' | transloco"
          [options]="creationModes"
          [filter]="false"
          styleClass="w-full"
          id="creationMode"
          optionLabel="label"
          optionValue="value"
          formControlName="creationMode"
        >
          <ng-template let-mode pTemplate="selectedItem"> {{mode.label | transloco}} </ng-template>
          <ng-template let-mode pTemplate="item"> {{mode.label | transloco}} </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="col-12 md:col-12 lg:col-6 xl:col-4" *ngIf="mode === 'create'">
      <div class="form-field col-12">
        <label for="tenant">{{'model.tenant' | transloco}} (*)</label>
      </div>
      <div class="col-12">
        <p-dropdown
          [placeholder]="'select.tenant' | transloco"
          [options]="tenants"
          [filter]="true"
          (onChange)="onTenantChange($event)"
          styleClass="w-full"
          id="tenant"
          optionLabel="name"
          dataKey="uuid"
          formControlName="tenant"
          #tenantSelector
        ></p-dropdown>
      </div>
    </div>

    <div class="col-12 lg:col-6 xl:col-4" *ngIf="mode === 'create'">
      <div class="form-field col-12">
        <label for="organization">{{'model.organization' | transloco}}</label><br>
      </div>
      <div class="col-12">
        <p-dropdown
          [placeholder]="'select.organization' | transloco"
          [options]="organizations"
          [filter]="true"
          [showClear]="true"
          (onChange)="onOrganizationChange($event)"
          styleClass="w-full"
          id="organization"
          optionLabel="name"
          dataKey="uuid"
          formControlName="organization"
          #organizationSelector
        ></p-dropdown>
      </div>
    </div>

    <div class="col-12 lg:col-6 xl:col-4">
      <div class="form-field col-12">
        <label for="measurementType">{{'model.sensorType' | transloco}}</label><br>
      </div>
      <div class="col-12">
        <p-dropdown
          [placeholder]="'select.type' | transloco"
          [options]="measurementTypes"
          [filter]="true"
          [showClear]="true"
          styleClass="w-full"
          id="measurementType"
          optionLabel="sensor"
          formControlName="measurementType"
        ></p-dropdown>
      </div>
    </div>

    <div class="col-12 lg:col-6 xl:col-4" *ngIf="mode === 'create'">
      <div class="form-field col-12">
        <label for="timePeriod">{{'attribute.timePeriod' | transloco}} (*)</label><br>
      </div>
      <div class="col-12">
        <p-dropdown
          [placeholder]="'select.generic' | transloco"
          [options]="timePeriods"
          [filter]="false"
          styleClass="w-full"
          id="timePeriod"
          optionLabel="label"
          optionValue="value"
          formControlName="timePeriod"
        >
          <ng-template let-timePeriod pTemplate="selectedItem"> {{timePeriod.label | transloco}} </ng-template>
          <ng-template let-timePeriod pTemplate="item"> {{timePeriod.label | transloco}} </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="col-12 lg:col-6 xl:col-4" *ngIf="mode === 'create'">
      <div class="form-field col-12">
        <label for="operation">{{'attribute.operation' | transloco}} (*)</label><br>
      </div>
      <div class="col-12">
        <p-dropdown
          [placeholder]="'select.generic' | transloco"
          [options]="operations"
          [filter]="false"
          styleClass="w-full"
          id="operation"
          optionLabel="label"
          optionValue="value"
          formControlName="operation"
        >
          <ng-template let-operation pTemplate="selectedItem"> {{operation.label | transloco}} </ng-template>
          <ng-template let-operation pTemplate="item"> {{operation.label | transloco}} </ng-template>
        </p-dropdown>
      </div>
    </div>

    <div class="col-12 md:col-12 lg:col-6 xl:col-4" *ngIf="mode === 'create'">
      <div class="form-field col-12">
        <label for="timezone">{{'attribute.timezone' | transloco}}</label>
      </div>
      <div class="col-12">
        <p-dropdown
          [placeholder]="'select.timezone' | transloco"
          [options]="timezones"
          [filter]="true"
          styleClass="w-full"
          id="timezone"
          optionValue="name"
          optionLabel="name"
          formControlName="timezone"
        ></p-dropdown>
      </div>
    </div>

    <div class="col-12 md:col-12 lg:col-6 xl:col-4" *ngIf="mode === 'create'">
      <div class="form-field col-12">
        <label for="calculateIfMissingData">{{'attribute.calculateIfMissingData' | transloco}}</label>
        <i [pTooltip]="'info.kpisForm.calculateIfMissingData' | transloco" class="pi pi-info-circle ml-2"></i>
      </div>
      <div class="col-12">
        <p-checkbox
          id="calculateIfMissingData"
          formControlName="calculateIfMissingData"
          binary="true"
          class="w-full"
        ></p-checkbox>
      </div>
    </div>

  </div>
</form>
